import { toAppError } from '../lib/appErrors.js';

// The shared error surface, on tokens (M-12 / V-03). It used to be
// hardcoded dark-mode (`bg-red-950/35 text-red-100`), so the light
// flightops theme rendered pale red on pale red. Now: the border and wash
// are the theme's `--color-err` mixed into the theme's surface, and the
// text is the AA-measured `--color-err-text` / `--color-text` pair, so the
// notice inverts with the theme instead of fighting it.
const FRAME = 'rounded-md border border-[color-mix(in_srgb,var(--color-err)_45%,transparent)] bg-[color-mix(in_srgb,var(--color-err)_12%,var(--color-surface))]';

export default function ErrorNotice({ error, className = '' }) {
  if (!error) return null;
  const issue = toAppError(error);
  return (
    <div role="alert" className={`${FRAME} px-3 py-2.5 text-sm ${className}`}>
      <div className="font-semibold text-[var(--color-err-text)]">{issue.title}</div>
      <div className="mt-0.5 text-[var(--color-text)]">{issue.message}</div>
      {issue.action && <div className="mt-1 text-xs text-[var(--color-text-muted)]">Next: {issue.action}</div>}
      {issue.requestId && (
        <div className="mt-1.5 font-mono text-micro text-[var(--color-text-muted)]" title="Give this ID to an administrator">
          Request ID: {issue.requestId}
        </div>
      )}
    </div>
  );
}
